import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from '../../app/app-routing.module';
import {AuthRoutingModule} from './auth-routing.module';
import {LoginComponent} from './components';
import {TermsOfServiceComponent} from './components/terms-of-service/terms-of-service.component';
import {I18NextModule} from 'angular-i18next';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {CodeInputModule} from 'angular-code-input';
import {SetPinComponent} from './components/set-pin/set-pin.component';
import {BiometricLoginComponent} from './components/biometric-login/biometric-login.component';

@NgModule({
  declarations: [LoginComponent, TermsOfServiceComponent, SetPinComponent, BiometricLoginComponent],
  imports: [AuthRoutingModule, AppRoutingModule, CommonModule, I18NextModule, ReactiveFormsModule, SharedModule, CodeInputModule]
})
export class AuthModule {
}
